export const MESSAGE_GROUP_DECK_SIZE = 10;

/**
 * Draws one random ballot for an iMessage-hosted group.
 *
 * The result is written to the session before anyone swipes. Guests never run
 * this function themselves, which is what keeps every device on the same deck.
 * `random` is injectable so the selection and cap are deterministic in tests.
 *
 * @param {import('../../lib/types.js').Restaurant[]} catalogue
 * @param {() => number} [random]
 */
export function randomGroupDeck(catalogue, random = Math.random) {
  const ids = [...new Set(catalogue.map((restaurant) => restaurant.id))];

  for (let index = ids.length - 1; index > 0; index -= 1) {
    const swapWith = Math.floor(random() * (index + 1));
    [ids[index], ids[swapWith]] = [ids[swapWith], ids[index]];
  }

  return {
    mode: 'manual',
    restaurantIds: ids.slice(0, MESSAGE_GROUP_DECK_SIZE),
    promotedIds: [],
  };
}

/** Builds a persisted ballot while keeping live Google content out of Firebase. */
export function manualGroupDeck(restaurants) {
  return {
    mode: 'manual',
    restaurantIds: restaurants.map((restaurant) => restaurant.id).slice(0, MESSAGE_GROUP_DECK_SIZE),
    promotedIds: [],
    googlePlaceIds: Object.fromEntries(
      restaurants
        .filter((restaurant) => restaurant.googlePlaceId)
        .slice(0, MESSAGE_GROUP_DECK_SIZE)
        .map((restaurant) => [String(restaurant.id), restaurant.googlePlaceId])
    ),
  };
}
